import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="bg-navy-deep text-muted-cream border-t border-line-navy pt-14 pb-8 text-sm">
      <div className="max-w-site mx-auto px-7">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-9 mb-10">
          {/* Brand column */}
          <div>
            <Link href="/" className="flex items-center gap-2.5 mb-4">
              <AppLogo size={28} />
              <span className="font-display text-lg font-bold tracking-widest text-white">
                Command<b className="text-primary">VA</b>
              </span>
            </Link>
            <p className="text-sm text-muted-cream max-w-[34ch] leading-relaxed">
              We book the meetings. You close the deals.
            </p>
            <p className="mt-2.5 font-mono text-[12.5px]">
              <a
                href="mailto:william@commandva.com"
                className="text-primary hover:text-gold-bright transition-colors"
              >
                william@commandva.com
              </a>
            </p>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-mono text-[11.5px] tracking-[0.18em] uppercase text-primary mb-4">
              Company
            </h4>
            <nav className="space-y-2">
              <Link href="/homepage" className="block py-1 text-muted-cream hover:text-white transition-colors">
                How we work
              </Link>
              <Link href="/industries" className="block py-1 text-muted-cream hover:text-white transition-colors">
                Industries served
              </Link>
              <Link href="/pricing" className="block py-1 text-muted-cream hover:text-white transition-colors">
                Pricing
              </Link>
              <Link href="/math" className="block py-1 text-muted-cream hover:text-white transition-colors">
                The math
              </Link>
              <Link href="/blog" className="block py-1 text-muted-cream hover:text-white transition-colors">
                Blog
              </Link>
            </nav>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="font-mono text-[11.5px] tracking-[0.18em] uppercase text-primary mb-4">
              Solutions
            </h4>
            <nav className="space-y-2">
              <Link href="/expand" className="block py-1 text-muted-cream hover:text-white transition-colors">
                Extend your sales team
              </Link>
              <Link href="/replace-ai-sdr" className="block py-1 text-muted-cream hover:text-white transition-colors">
                Replace your AI SDR
              </Link>
              <Link href="/just-raised-a-b" className="block py-1 text-muted-cream hover:text-white transition-colors">
                Just raised A or B
              </Link>
              <Link href="/first-sdr-function" className="block py-1 text-muted-cream hover:text-white transition-colors">
                Your first SDR function
              </Link>
              <Link href="/switching-providers" className="block py-1 text-muted-cream hover:text-white transition-colors">
                Switching providers
              </Link>
            </nav>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-mono text-[11.5px] tracking-[0.18em] uppercase text-primary mb-4">
              Connect
            </h4>
            <nav className="space-y-2">
              <a
                href="/request-meeting"
                className="block py-1 text-muted-cream hover:text-white transition-colors"
              >
                Book a strategy call
              </a>
              <a
                href="https://www.linkedin.com/company/commandva/"
                target="_blank"
                rel="noopener noreferrer"
                className="block py-1 text-muted-cream hover:text-white transition-colors"
              >
                LinkedIn
              </a>
              <a
                href="https://commandva.com/va-application"
                target="_blank"
                rel="noopener noreferrer"
                className="block py-1 text-muted-cream hover:text-white transition-colors"
              >
                Apply as an SDR
              </a>
            </nav>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-line-navy pt-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 font-mono text-[12px] tracking-[0.06em]">
          <span className="text-muted-cream/60">© 2026 CommandVA LLC. All rights reserved.</span>
          <span className="text-muted-cream/40 text-[10px] tracking-[0.14em] uppercase">
            COLD CALLING FIRST · PUBLISHED PRICING · MONTH TO MONTH
          </span>
        </div>
      </div>
    </footer>
  );
}